<template>
  <div class="b-vehicle-compare-bar-card" title="Remove" @click="onClickCard">
    <div>
      <LazyImage v-if="image" :image="image" />
    </div>
    <div>
      <div class="extrabold">{{ item.make }} {{ item.model }}</div>
      <div class="b-vehicle-compare-bar-card__description semibold">
        {{ modelNameComputed }}
      </div>
      <a class="b-vehicle-compare-bar-card__button">
        {{ dictionary.compareRemoveButtonLabel }}
      </a>
    </div>
  </div>
</template>

<script>
import mixinsLeasingOffers from './../../mixins/leasingOffers-mixins'
import LazyImage from './../common/LazyImage.vue'

export default {
  components: { LazyImage },
  mixins: [mixinsLeasingOffers],
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    modelNameComputed() {
      if (!this.item) {
        return null
      }
      return this.item.modelDescription
    },

    image() {
      return this.item.galleryImages
        ? {
            url: this.item.galleryImages[0].url,
            alt: this.item.galleryImages[0].alt,
          }
        : null
    },
  },
  methods: {
    onClickCard() {
      this.removeRecordFromCompare({ value: this.item.id })
    },
  },
}
</script>

<style scoped lang="scss">
.b-vehicle-compare-bar-card {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  img {
    max-height: 40px;
  }

  &__description {
    font-size: 12px;
    line-height: 1.1rem;
    height: 30px;
  }

  &__button {
    font-size: 12px;
    font-weight: 600;
    color: #c71818;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
